"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROVIDER_EVENTS = void 0;
exports.PROVIDER_EVENTS = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed",
    UPDATE_NAMESPACES: "update_name_spaces",
};
